import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFacebook,
    faInstagram,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import Routes from 'src/constants/Routes';
import { isCountry } from 'src/constants/Countries';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type SocialMediaItem = {
    label: string;
    icon: IconProp;
    altText: string;
    url: string;
};

const list = [
    {
        label: 'Facebook',
        icon: faFacebook,
        altText: 'Follow us on Facebook',
        url: Routes.FACEBOOK,
    },
    {
        label: 'Instagram',
        icon: faInstagram,
        altText: 'Follow us on Instagram',
        url: Routes.INSTAGRAM,
    },
    {
        label: 'YouTube',
        icon: faYoutube,
        altText: 'Follow us on YouTube',
        url: Routes.YOUTUBE,
    },
] as SocialMediaItem[];

const filteredList = list.filter((item) => {
    if (isCountry('AU')) {
        return item.label !== 'YouTube';
    }
    return true;
});

export default function SocialMediaList() {
    return (
        <div className="flex items-center justify-center gap-4">
            {filteredList.map((item, index) => (
                <a
                    className="inline-block"
                    key={index}
                    title={item.altText}
                    href={item.url}
                    target={'_blank'}
                >
                    <FontAwesomeIcon
                        className="size-6 p-2 hover:text-blue-extra-light"
                        icon={item.icon}
                        size="xl"
                    />
                </a>
            ))}
        </div>
    );
}
